export const DEFAULT_ICON_SIZE_CUSTOM_CSS_PROPERTY_NAME = '--icon-default-size-in-px';
